/**
 * A business-unit filter for the Discovery cards that read a unit-scoped report
 * (release 8, C4 and C5). The options are the units the reader may see, plus
 * "Unassigned"; the server limits what is returned to the reader's units either
 * way, so this only narrows. If the units cannot be listed the select is not
 * shown and the card stays on "all of yours".
 */

import { useEffect, useState } from 'react';

import { listBusinessUnits } from '@/lib/api';

interface Option {
  value: string;
  label: string;
}

export function BuFilterSelect({
  value,
  onChange,
  id,
}: {
  value: string;
  onChange: (bu: string) => void;
  id: string;
}) {
  const [options, setOptions] = useState<Option[]>([]);
  useEffect(() => {
    let live = true;
    listBusinessUnits({ status: 'active' }).then(
      (r) => {
        if (live) setOptions([...r.businessUnits.map((b) => ({ value: b.id, label: b.name })), { value: 'unassigned', label: 'Unassigned' }]);
      },
      () => {
        if (live) setOptions([]);
      },
    );
    return () => {
      live = false;
    };
  }, []);
  if (options.length === 0) return null;
  return (
    <div className="flex items-center gap-2">
      <label className="text-xs text-muted-foreground" htmlFor={id}>
        Business unit
      </label>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="glass-lite text-sm rounded px-2 py-1 bg-background/40 border border-border/40"
      >
        <option value="">All of mine</option>
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </div>
  );
}
